import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {FreeSpinsModule} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';

export class FreeSpinsProgressState extends ModuleState<FreeSpinsView, FreeSpinsModule> {
	protected _isWaitingForInitialAnimationToFinish: boolean = false;

	public onEnterState(): void {
		this.module.logic.isFreeSpinsStarted = true;
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FlowModuleEvents.FREE_SPINS_FINISHED, this.onFreeSpinsFinished);
		this.on(FlowModuleEvents.FREESPINS_RETRIGGER_WIN, this.onFreeSpinsRetriggered);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
	}

	protected onFreeSpinsRetriggered(): void {
		this.view.showAddedFreespins(this.module.logic.freeSpinsAdded);
	}

	protected onCanSpin(): void {
		if (this.module.logic.freeSpinsLeft > 0) {
			this.emit(FreeSpinsEvents.FREE_SPIN_STARTED);
		}
	}

	protected onFreeSpinsFinished(): void {
		this.finishFreeSpins();
	}

	protected finishFreeSpins(): void {
		this.module.logic.isFreeSpinsStarted = false;
		this.module.gotoState(FreeSpinsModule.OUTRO_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsProgressState.ts